import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, merge, startWith, switchMap } from 'rxjs';
import { ContactGrouopService } from 'src/app/private/services/contact-groups.service';
import { UsersService } from 'src/app/private/services/users.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

export interface DataElement {
  id: number;
  name: string;
}


@Component({
  selector: 'app-add-contacts-group',
  templateUrl: './add-contacts-group.component.html',
  styleUrls: ['./add-contacts-group.component.scss']
})


export class AddContactsGroupComponent {


  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() formSubmit: EventEmitter<any> = new EventEmitter();

  @Input() selectedGroupId: any;


  totalRows = 0;
  currentPage = 0;
  pageSize = 25;
  pageSizeOptions: number[] = [10, 25, 100];
  @ViewChild('paginator', { static: false }) paginator!: MatPaginator;

  @ViewChild(MatSort)
  sort!: MatSort;
  searchQuery = new FormControl();
  dateQuery = new FormControl();
  currentData = [];

  initialLoad = true;

  isSubmitted = false;
  btnLoading = false;
  selectedIds: number[] = [];
  isAdmin = false;

  constructor(
    private toast: ToastrService,
    private api: ContactGrouopService,
    private localStorage: LocalStorageService,
    private userApi: UsersService,
    private cdr: ChangeDetectorRef
  ) {
    this.isAdmin = this.localStorage.checkFullAccessForTableList(
      this.localStorage.getRole()
    );
  }

  displayedColumns = ['select', 'name', 'email', 'phone'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  selection = new SelectionModel<any>(true, []);
  selectedLeadIds: number[] = [];
  isAllLeadsSelected = false;


  GroupListData: any = [];

  ngOnInit() {
    this.GroupListData = [];
    // this.getLeadAndContactId();
  }

  // this function is used to get the lead and contact id from the contact group which are already added
  getLeadAndContactId() {
    try {
      const payload = {
        contact_group_id: this.selectedGroupId
      }
      this.api.getLeadAndContactId(payload).subscribe(
        (response) => {
          this.GroupListData = response;
          this.GroupListData.forEach((element: any) => {
            if (element.lead_id) {
              this.selectedLeadIds.push(element.lead_id);
            }
          });
          this.isAllSelected();
        },
        (error) => {
          console.log(error);
          this.toast.error("Error while fetching contact group");
        }
      );

    } catch (e) {
      console.error(e);
    }
  }

  ngAfterViewInit() {
    this.getLeads();
  }

  // this function is used to get the leads from the api which are already added to the leads table
  getLeads() {
    try {
      merge(
        this.paginator.page
      )
        .pipe(
          startWith({}),
          switchMap(() => {

            const param: any = {
              "where": {
                "hospital_id": this.localStorage.getHospitalId(),
              },
              "filter": null,
              "page": this.paginator.pageIndex * this.paginator.pageSize,
              "limit": this.paginator.pageSize,
              "order": {
                "col": "\"updatedAt\"",
                "dir": "DESC"
              }
            }

            if (!this.isAdmin) {
              param.where.user_id = this.localStorage.getUserId();
            }

            return this.api
              .getAllLeads(param)
              .pipe(catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            return response.rows;
          })
        )
        .subscribe({
          next: (data) => {
            this.dataSource = new MatTableDataSource<any>(data);
            this.currentData = data;
            this.initialLoad = false;

            this.isAllSelected();
          },
          error: (e) => {
            console.error(e);
            this.toast.error("Error while fetching leads");
            this.initialLoad = false;
          },
          complete: () => {
          },
        });
    } catch (e) {
      console.error(e);
    }
  }

  // this function is used to check if all the leads are selected
  isAllSelected() {

    if (this.initialLoad) {
      return;
    }

    if (this.currentData.length === 0) {
      return
    }

    const result = this.currentData.every((x: any) => this.selectedLeadIds.includes(
      parseInt(x.lead_id, 10)
    ) || this.selection.isSelected(x) || !!this.GroupListData.find((y: any) => y.lead_id == x.lead_id));

    if (result) {
      this.isAllLeadsSelected = true;
    } else {
      this.isAllLeadsSelected = false;
    }
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle(event: any) {

    if (this.isAllLeadsSelected) {
      this.selection.clear();

      this.dataSource.data.forEach(row => {
        this.selectedLeadIds = this.selectedLeadIds.filter((x) => x != row.lead_id);
      });

      this.isAllLeadsSelected = false;
    } else {
      this.dataSource.data.forEach(row => {
        if (this.selectedLeadIds.includes(
          parseInt(row.lead_id, 10)
        )) {
          return;
        }
        this.selection.select(row);
        this.addToLeadsIds(row);
      });
      this.isAllLeadsSelected = true;
    }
  }


  closeModal() {
    this.close.emit();
  }

  // this function is used to submit the form and add the selected contacts and leads to the contact group
  onSubmit() {

    let contacts: any = []

    this.selection.selected.forEach((element) => {

      if (this.GroupListData.find((x: any) => x.lead_id == element.lead_id)) {
        return;
      }

      contacts.push({
        name: element.fname + ' ' + element.lname,
        source: element.leadChannel || 'manual',
        phone: element.mobile,
        email: element.email,
        lead_id: element.lead_id
      })
    })

    if (contacts.length === 0) {
      this.toast.warning("Please select at least one contact");
      return;
    }

    const payload = {
      hospital_id: this.localStorage.getHospitalId(),
      contact_group_id: this.selectedGroupId,
      contacts: contacts
    }

    this.btnLoading = true;

    this.api.createContactGroupList(payload).subscribe(
      (response) => {
        this.formSubmit.emit();
      },
      (error) => {
        console.log(error);
        this.toast.error("Error while creating contact group");
        this.btnLoading = false;
      }
    );
  }


  // checking for the selected row for the leads
  isRowSelected(row: any): boolean {
    const result = this.selectedLeadIds.includes(
      parseInt(row.lead_id, 10)
    ) || this.selection.isSelected(row) || !!this.GroupListData.find((x: any) => x.lead_id == row.lead_id);

    return result;
  }

  // checking for the disabled row for the leads
  isDisabled(row: any): boolean {
    return !!this.GroupListData.find((x: any) => x.lead_id == row.lead_id);
  }


  // adding the selected row to the selectedLeadIds for the leads table
  addToLeadsIds(row: any) {

    if (this.selectedLeadIds.includes(row.lead_id)) {
      this.selectedLeadIds = this.selectedLeadIds.filter((x) => x !== row.lead_id);
      return;
    } else {
      this.selectedLeadIds.push(parseInt(row.lead_id, 10));
    }

    this.isAllSelected();
  }


  // Valid Email
  isValidEmail(email: any): boolean {
    if (!email) return false;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  // Valid Mobile with Country Code (e.g., 919876543210)
  isValidPhone(phone: any): boolean {
    if (!phone) return false;
    const phoneRegex = /^[0-9]{10,15}$/;
    return phoneRegex.test(phone);
  }
}



function observableOf(arg0: null): any {
  console.log(arg0);
  throw new Error('Function not implemented.');
}
